import { render, staticRenderFns } from "./UserTweets.vue?vue&type=template&id=21e5c9b2&"
import script from "./UserTweets.vue?vue&type=script&lang=js&"
export * from "./UserTweets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports